export enum UserRole {
    Host,
    Guest,
}
